import { render } from "./KnowledgeDocuments.vue?vue&type=template&id=25f99869&scoped=true"
import script from "./KnowledgeDocuments.vue?vue&type=script&lang=js"
export * from "./KnowledgeDocuments.vue?vue&type=script&lang=js"

import "./KnowledgeDocuments.vue?vue&type=style&index=0&id=25f99869&scoped=true&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-25f99869"]])

export default __exports__